



import { Component, Vue } from 'vue-property-decorator';

import Pagination from '@/shared/components/Pagination/Pagination.component.vue';

@Component({
  components: {
      Pagination,
  },
})

export default class PartialPagination extends Vue {

    private seeAllFlag: any = { first: false, second: false };
    private activePage: any = { first: 1, second: 1 };
    private itemsPerPage: any = { first: 10, second: 10 };
    private totalItems: any = { first: 243, second: 1532 };
    private moreItemsPerPageShowed: any = { first: false, second: false };

    private goPage( payload: any, index: string ) {
        // Ajax goes here
        this.activePage[ index ] = payload.page;
    }

    private seeAll( payload: any, index: string ) {
        // Ajax goes here
        this.seeAllFlag[ index ] = true;
    }

    private moreItemsPerPage( payload: any, index: string ) {
        // Ajax goes here
        this.itemsPerPage[ index ] = payload.multiplier * this.itemsPerPage[ index ];
        this.moreItemsPerPageShowed[ index ] = true;
    }

    private lessItemsPerPage( payload: any, index: string ) {
        // Ajax goes here
        this.itemsPerPage[ index ] = this.itemsPerPage[ index ] / payload.divider;
        this.moreItemsPerPageShowed[ index ] = false;
    }

}
